import styled, { css } from 'styled-components';
import { crTheme } from '@comicrelief/component-library';
import { StyledFieldset } from '../global/Global.style';
import { MoneybuyLabelProps } from './types';

const MoneybuysWrapper = styled(StyledFieldset)`
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 20px;
    @media ${crTheme.allBreakpoints('M')} {
        flex-direction: row;
        gap: 15px;
    }
`;

const MoneybuyRadioButton = styled.input`
    // Hiding the button itself, letting us purely use
    // the wrapping label as the 'button'
    display: none;
`;

const MoneybuyLabel = styled.label<MoneybuyLabelProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    flex-basis: 0;
    padding: 18px 30px;
    font-family: Anton, Impact, sans-serif;
    font-size: 27px;
    line-height: 27px;
    text-align: center;
    font-weight: bold;
    background: ${crTheme.color('blue_light')};
    color: ${crTheme.color('black')};
    border-radius: 0.5rem;
    transition: background-color linear 0.2s, color linear 0.2s;
    flex-direction: column;

    &:hover {
        // TO-DO: suss out filters
        background-color: #d5dfff;
    }

    ${({ selected }) => (selected && css`
        background-color: ${crTheme.color('blue_donate')};
        color: ${crTheme.color('white')};

        &:hover {
            background-color: #011a85;
        }
    `)};

    @media ${crTheme.allBreakpoints('M')} {
        flex-direction: row;
        margin-bottom: 0;
        border-radius: 0.5rem;
    }
`;

const MoneybuyDescriptionWrapper = styled.div`
    width: 90%;
    margin: 25px auto 0;
    text-align: center;
    p span {
        margin-right: 5px;
    }
`;

export {
  MoneybuysWrapper, MoneybuyRadioButton, MoneybuyLabel, MoneybuyDescriptionWrapper
};
